import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './queen.css'

const Queen = (props) => {
  return (
    <div className="queen-container1">
      <Helmet>
        <title>Queen - Sycorax Cats</title>
        <meta property="og:title" content="Queen - Sycorax Cats" />
        <link
          rel="canonical"
          href="https://sycorax.uk/queen"
        />
        <meta
          property="og:url"
          content="https://sycorax.uk/queen"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-media-container">
          <img
            alt="Pandora - Sycorax Cats Breeding Queen"
            src="/pxl_20251017_144140360.portrait-1500h.jpg"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="hero-text-block">
            <span className="section-subtitle">Sycorax Cats Queen</span>
            <h1 className="page-hero-title hero-title">Pandora</h1>
            <p className="section-content">
              Our stunning registered GCCF breeding queen, full designation
              Jolleytots Midnight Melody. This beautiful girl is everything
              I&apos;ve ever wanted. She&apos;s so affectionate, reads the room
              when it comes to other cats wanting to play or not, and LOVES to
              play fetch with us!
            </p>
          </div>
          <div className="queen-thq-health-details-elm health-details">
            <div className="queen-thq-detail-badge-elm1 detail-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                className="queen-thq-icon-elm"
              >
                <path
                  d="m10 16l1.5 1.5M14 8l-1.5-1.5M15 2c-1.798 1.998-2.518 3.995-2.807 5.993M16.5 10.5l1 1M17 6l-2.891-2.891M2 15c6.667-6 13.333 0 20-6m-2 0l.891.891M3.109 14.109L4 15m2.5-2.5l1 1M7 18l2.891 2.891M9 22c1.798-1.998 2.518-3.995 2.807-5.993"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span className="queen-text1">
                PRA n/n
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <div className="queen-thq-detail-badge-elm2 detail-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                className="queen-icon2"
              >
                <path
                  d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span className="queen-text2">Cinnamon Carrier</span>
            </div>
            <div className="queen-thq-detail-badge-elm3 detail-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                className="queen-icon4"
              >
                <path
                  d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span className="queen-text3">Dilute Carrier</span>
            </div>
          </div>
        </div>
      </section>
      <section className="photo-gallery-section">
        <div className="gallery-container">
          <div className="gallery-header">
            <h2 className="section-title">Pandora&apos;s Gallery</h2>
          </div>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img
                alt="Pandora close up portrait"
                src="/pxl_20260217_123213415.portrait-1500w.jpg"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                alt="Pandora resting"
                src="/pxl_20260619_180423059.portrait-1500w.jpg"
                className="queen-thq-gallery-image-elm2 gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                alt="Pandora profile view"
                src="/pxl_20260609_123912011.portrait.original-1500w.jpg"
                className="gallery-image"
              />
            </div>
            <div className="item-large gallery-item">
              <img
                alt="Pandora in natural light"
                src="/pxl_20260406_163549404.portrait-1500w.jpg"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                alt="Pandora striking eyes"
                src="/pxl_20260705_183903319.portrait-1500w.jpg"
                className="gallery-image"
              />
            </div>
            <div className="gallery-item">
              <img
                alt="Pandora lounging"
                src="/pxl_20260706_180003051.portrait-1500w.jpg"
                className="gallery-image"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="queen-container2">
        <div className="queen-container3">
          <Script
            html={`<script defer data-name="gallery-interaction">
(function(){
  /* No specific JavaScript required for this static profile page. 
   Interaction is handled via CSS hover states for the gallery images. */
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Queen
